/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayVolumeSettings_ConfigFragment = { __typename: 'ConfigurationModel', id: string, volume?: { __typename: 'ConfigVolume', isMuted?: { __typename: 'ConfigVolumeMuteState', reported: boolean } | null, level?: { __typename: 'ConfigVolumeLevelState', reported: number } | null, limits?: { __typename: 'ConfigVolumeLimitState', min?: { __typename: 'VolumeLimit', reported: number } | null, max?: { __typename: 'VolumeLimit', reported: number } | null } | null } | null };

export type ConfigUpdateVolumeLevelMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateVolumeLevelInput;
}>;


export type ConfigUpdateVolumeLevelMutation = { __typename: 'Mutation', configurationUpdateVolumeLevel: { __typename: 'ConfigurationModel', id: string, volume?: { __typename: 'ConfigVolume', isMuted?: { __typename: 'ConfigVolumeMuteState', reported: boolean } | null, level?: { __typename: 'ConfigVolumeLevelState', reported: number } | null, limits?: { __typename: 'ConfigVolumeLimitState', min?: { __typename: 'VolumeLimit', reported: number } | null, max?: { __typename: 'VolumeLimit', reported: number } | null } | null } | null } };

export type ConfigUpdateVolumeMuteMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateVolumeMuteInput;
}>;


export type ConfigUpdateVolumeMuteMutation = { __typename: 'Mutation', configurationUpdateVolumeMute: { __typename: 'ConfigurationModel', id: string, volume?: { __typename: 'ConfigVolume', isMuted?: { __typename: 'ConfigVolumeMuteState', reported: boolean } | null, level?: { __typename: 'ConfigVolumeLevelState', reported: number } | null, limits?: { __typename: 'ConfigVolumeLimitState', min?: { __typename: 'VolumeLimit', reported: number } | null, max?: { __typename: 'VolumeLimit', reported: number } | null } | null } | null } };

export const ConfigDisplayVolumeSettings_ConfigFragmentDoc = gql`
    fragment ConfigDisplayVolumeSettings_config on ConfigurationModel {
  id
  volume {
    isMuted {
      reported
    }
    level {
      reported
    }
    limits {
      min {
        reported
      }
      max {
        reported
      }
    }
  }
}
    `;
export const ConfigUpdateVolumeLevelDocument = gql`
    mutation ConfigUpdateVolumeLevel($input: ConfigurationUpdateVolumeLevelInput!) {
  configurationUpdateVolumeLevel(input: $input) {
    id
    ...ConfigDisplayVolumeSettings_config
  }
}
    ${ConfigDisplayVolumeSettings_ConfigFragmentDoc}`;
export type ConfigUpdateVolumeLevelMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateVolumeLevelMutation, ConfigUpdateVolumeLevelMutationVariables>;

/**
 * __useConfigUpdateVolumeLevelMutation__
 *
 * To run a mutation, you first call `useConfigUpdateVolumeLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateVolumeLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateVolumeLevelMutation, { data, loading, error }] = useConfigUpdateVolumeLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateVolumeLevelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateVolumeLevelMutation, ConfigUpdateVolumeLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateVolumeLevelMutation, ConfigUpdateVolumeLevelMutationVariables>(ConfigUpdateVolumeLevelDocument, options);
      }
export type ConfigUpdateVolumeLevelMutationHookResult = ReturnType<typeof useConfigUpdateVolumeLevelMutation>;
export type ConfigUpdateVolumeLevelMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateVolumeLevelMutation>;
export type ConfigUpdateVolumeLevelMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateVolumeLevelMutation, ConfigUpdateVolumeLevelMutationVariables>;
export const ConfigUpdateVolumeMuteDocument = gql`
    mutation ConfigUpdateVolumeMute($input: ConfigurationUpdateVolumeMuteInput!) {
  configurationUpdateVolumeMute(input: $input) {
    id
    ...ConfigDisplayVolumeSettings_config
  }
}
    ${ConfigDisplayVolumeSettings_ConfigFragmentDoc}`;
export type ConfigUpdateVolumeMuteMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateVolumeMuteMutation, ConfigUpdateVolumeMuteMutationVariables>;

/**
 * __useConfigUpdateVolumeMuteMutation__
 *
 * To run a mutation, you first call `useConfigUpdateVolumeMuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateVolumeMuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateVolumeMuteMutation, { data, loading, error }] = useConfigUpdateVolumeMuteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateVolumeMuteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateVolumeMuteMutation, ConfigUpdateVolumeMuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateVolumeMuteMutation, ConfigUpdateVolumeMuteMutationVariables>(ConfigUpdateVolumeMuteDocument, options);
      }
export type ConfigUpdateVolumeMuteMutationHookResult = ReturnType<typeof useConfigUpdateVolumeMuteMutation>;
export type ConfigUpdateVolumeMuteMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateVolumeMuteMutation>;
export type ConfigUpdateVolumeMuteMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateVolumeMuteMutation, ConfigUpdateVolumeMuteMutationVariables>;